import { CLASS_NAME } from 'constants/class-names'
import { Nullable } from 'constants/types'
import { EventType } from 'constants/enums'
import { ComponentBase } from 'utils/abstract-classes/component-base'

export class VehicleSortForm extends ComponentBase {
    private sortSelect: Nullable<HTMLSelectElement>

    public constructor(private vehicleSortForm: HTMLFormElement) {
        super()
        this.sortSelect = this.getElement<HTMLSelectElement>(
            `.${CLASS_NAME.common.formControl}`,
            vehicleSortForm
        )

        if (this.sortSelect) {
            this.sortSelect.addEventListener(EventType.CHANGE, () => {
                this.submitForm()
            })
        }
    }

    private submitForm(): void {
        this.vehicleSortForm.submit()
    }
}
